import { render, staticRenderFns } from "./ParcialInfo.vue?vue&type=template&id=30f4c82a&"
import script from "./ParcialInfo.vue?vue&type=script&lang=js&"
export * from "./ParcialInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports